import { FulfilmentType } from '../../../../../../models/fulfilment'
import {
  CurrentView,
  useLineItemFulfillmentContext,
} from '../LineItemFulfillmentContext'
import {
  isMissingName,
  isMissingContactInfo,
} from '../LineItemFulfillmentUtils'

export const useLineItemFulfillmentContinueButtonStatus = () => {
  const {
    currentView,
    fulfilmentDetails,
    currentCustomer,
    isEmailInvalid,
    isLoading,
    isFulfilmentNoteInvalid,
  } = useLineItemFulfillmentContext()

  const isContinueButtonDisabled = () => {
    switch (currentView) {
      case CurrentView.DECISION:
        return false
      case CurrentView.ADD_CUSTOMER:
        // In this view, the continue button is always disabled
        // The transition happens automatically when a customer is selected
        // or the user chooses to create a new customer
        return true
      case CurrentView.REVIEW_CONTACT_INFO:
      case CurrentView.CREATE_NEW_CUSTOMER:
        if (currentCustomer) {
          return (
            isMissingName(currentCustomer) ||
            isMissingContactInfo(currentCustomer) ||
            isEmailInvalid ||
            isLoading
          )
        } else {
          // We should never be able to reach here, but if we do, we block the continue button
          return true
        }
      case CurrentView.FULFILMENT_METHOD:
        return (
          fulfilmentDetails.type === FulfilmentType.UNSPECIFIED ||
          isFulfilmentNoteInvalid
        )
      default:
        return true
    }
  }

  return {
    isContinueButtonDisabled,
  }
}
